import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import { Base, IconButton } from '@gandi/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "InputTextAny-root_28SHH",
  "input": "InputTextAny-input_lJAa4"
};
export const InputTextAny = ({
  type = 'text',
  className,
  hasRemoveButton,
  removeButtonTitle,
  handleRemoveButton,
  ...extraProps
}) => {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsxs(Base, {
    flex: true,
    gap: "xsmall",
    className: clsx(styles.root, className),
    children: [/*#__PURE__*/_jsx("input", {
      type: type,
      className: styles.input,
      ...extraProps
    }), hasRemoveButton && /*#__PURE__*/_jsx(IconButton, {
      type: "button",
      flexShrink0: true,
      intent: "danger",
      kind: "ghost",
      icon: "cross",
      onClick: handleRemoveButton,
      children: removeButtonTitle || __('Remove field')
    })]
  });
};